<template>
  <div class="page-container">
    <loading v-if="loading" backcolor="#fff"></loading>
    <div v-else class="content-wrapper">
      <!-- 顶部渐变背景 -->
      <div class="top-gradient"></div>
      
      <!-- 顶部导航栏 - 定位 + 客服 -->
      <div class="top-header">
        <div class="location-bar" @click="Switch">
          <i class="iconfont icon-dingwei location-icon"></i>
          <span class="location-text">{{ address || '定位中...' }}</span>
          <i class="iconfont icon-iconfontarrows1 arrow-icon"></i>
        </div>
        <div class="service-entry" aria-label="在线客服" @click="openCustomerService">
          <van-icon name="service-o" size="1.3rem" />
        </div>
      </div>

      <platform-notice-bar page-code="movie_home" />

      <div class="scroll-container">
        
        <!-- 第一版块：缤纷商城入口 -->
        <div v-if="showShop" class="section-container" @click="goShop">
          <div class="shop-entry-card">
            <div class="shop-entry-left">
              <div class="shop-entry-icon-wrapper">
                <span class="shop-entry-icon">🛍️</span>
              </div>
              <div class="shop-entry-content">
                <div class="shop-entry-title">缤纷商城</div>
                <div class="shop-entry-subtitle">品质好物 · 一站购齐</div>
              </div>
            </div>
            <div class="shop-entry-btn">
              进入商城
              <i class="iconfont icon-iconfontarrows1"></i>
            </div>
          </div>
        </div>

        <!-- 第二版块：视听会员 -->
        <div v-if="showVideoMember" class="section-container">
          <div class="section-card">
            <div class="section-header">
              <div class="section-title">
                <span class="title-icon">👑</span>
                <span class="title-text">视听会员</span>
              </div>
              <div class="section-more" @click="goToCategory(videoMemberCategory)">
                全部 <i class="iconfont icon-iconfontarrows1"></i>
              </div>
            </div>
            <div v-if="videoMemberList.length > 0" class="horizontal-scroll">
              <div class="category-item" v-for="(item, index) in videoMemberList" :key="index"
                @click.stop="goToCategoryDetail(videoMemberCategory, index)">
                <div class="category-icon-wrapper">
                  <van-image fit="contain" :src="item.icon" class="category-icon" lazy-load />
                </div>
                <div class="category-name">{{ item.name }}</div>
              </div>
            </div>
            <div v-else class="empty-placeholder">
              <span>暂无内容</span>
            </div>
          </div>
        </div>

        <!-- 第三版块：观影美食（餐饮自提） -->
        <div v-if="showFoodOrder" class="section-container">
          <div class="section-card">
            <div class="section-header">
              <div class="section-title">
                <span class="title-icon">🍿</span>
                <span class="title-text">观影美食</span>
              </div>
              <div class="section-more" @click="goToFoodBrandList(foodOrderCategory)">
                全部 <i class="iconfont icon-iconfontarrows1"></i>
              </div>
            </div>
            <div v-if="foodBrandList.length > 0" class="horizontal-scroll">
              <div class="category-item" v-for="(item, index) in foodBrandList" :key="index"
                @click.stop="goToThirdH5(item)">
                <div class="category-icon-wrapper">
                  <van-image fit="contain" :src="item.icon" class="category-icon" lazy-load />
                </div>
                <div class="category-name">{{ item.name }}</div>
              </div>
            </div>
            <div v-else class="empty-placeholder">
              <span>暂无内容</span>
            </div>
          </div>
        </div>

        <!-- 第四版块：热门演出入口（淘福客，商城式小卡，紧贴热映上方） -->
        <div v-if="showHotShow" class="section-container" @click="goToHotShowBrandList(hotShowCategory)">
          <div class="shop-entry-card">
            <div class="shop-entry-left">
              <div class="shop-entry-icon-wrapper">
                <span class="shop-entry-icon">🎭</span>
              </div>
              <div class="shop-entry-content">
                <div class="shop-entry-title">热门演出</div>
                <div class="shop-entry-subtitle">演唱会 · 话剧 · 展会票务</div>
              </div>
            </div>
            <div class="shop-entry-btn">
              去看看
              <i class="iconfont icon-iconfontarrows1"></i>
            </div>
          </div>
        </div>

        <!-- 第五版块：正在热映 -->
        <div class="section-container movie-section" :class="{ 'is-vertical-only': !hasOtherSections }">
          <div class="section-header movie-header">
            <div class="section-title movie-title">
              <span class="title-icon">🎬</span>
              <span class="title-text">正在热映</span>
            </div>
            <div class="section-more movie-more" @click="goMore">
              全部 <i class="iconfont icon-iconfontarrows1"></i>
            </div>
          </div>
          <!-- 加载中：骨架屏 -->
          <div v-if="!categoryLoaded || loading" class="movie-skeleton">
            <div class="skeleton-item" v-for="i in 3" :key="i">
              <van-skeleton :row="3" :row-width="['60%', '80%', '50%']" avatar avatar-size="5.5rem" avatar-shape="square" />
            </div>
          </div>
          <!-- 有其他板块时：横向滚动展示 -->
          <div v-if="hasOtherSections && displayMovies.length > 0" class="horizontal-scroll movie-scroll">
            <div class="movie-card" v-for="(item, index) in displayMovies" :key="index">
              <div class="movie-poster-wrapper" @click="goMovieDetail(item)">
                <van-image fit="cover" :src="item.pic" class="movie-poster" lazy-load />
                <div class="poster-score" v-if="item.grade">{{ item.grade }}分</div>
                <div class="poster-version" v-if="item.versionTypes">{{ item.versionTypes }}</div>
              </div>
              <div class="movie-info">
                <div class="movie-name" @click="goMovieDetail(item)">{{ item.name }}</div>
                <div class="movie-buy-btn" @click="goCinema(item)">购票</div>
              </div>
            </div>
          </div>
          <!-- 只有电影权限时：使用 MovieItem 组件展示并支持内部滚动 -->
          <div v-else-if="!hasOtherSections && displayMovies.length > 0" class="movie-item-wrapper">
            <MovieItem :list="displayMovies" />
            <!-- 底部查看更多按钮 -->
            <div class="movie-bottom-more" @click="goMore">
              <span>查看更多影片</span>
              <i class="iconfont icon-iconfontarrows1"></i>
            </div>
          </div>
          <!-- 无影片状态 -->
          <div v-else class="movie-empty">
            <div class="movie-empty-icon">🎞️</div>
            <div class="movie-empty-text">当前城市暂无热映影片</div>
            <div class="movie-empty-tip">切换城市试试看</div>
          </div>
        </div>

      </div>
    </div>
    <!-- 引入定位组件并监听定位完成事件 -->
    <LocationComponent @location-finish="onLocationFinish" />
    <MovieNav />
  </div>
</template>
<script>
import MovieItem from "../../components/movie/MovieItem.vue";
import LocationComponent from '@/components/map/Location.vue';
import MovieNav from '../../components/footnav/MovieNav.vue';
import PlatformNoticeBar from '@/components/PlatformNoticeBar.vue';
import { openCustomerService } from '@/utils/customerService';
import {
  cacheAggregateChildren,
  isPortalL1,
  navigateToGoodsList,
} from '@/utils/categoryNav';
import { mapState } from 'vuex';
export default {
  name: 'MoviesHome',
  data() {
    return {
      loading: true,
      movies: [],
      form: {
        cityCode: ''
      },
      cardId: '',
      upgradeFlag: null,
      bathId: '',
      _lastBathId: null, // 换卡检测，与商城首页一致
      _loadedBathId: null, // 已成功拉数对应的批次，防定位/路由重复请求
      _loadedCityCode: null,
      dataLoaded: false,
      categoryLoaded: false, // 分类是否加载完成
      // 分类相关（同源商城首页 queryHomePageCategory.categoryList）
      categoryList: [],
      showVideoMember: false,
      showFoodOrder: false,
      showHotShow: false,
      showShop: false,
      videoMemberCategory: null,
      foodOrderCategory: null,
      hotShowCategory: null,
      shopCategoryList: [],
      videoMemberList: [],
      foodBrandList: [],
      hotShowBrandList: [],
    }
  },
  components: { LocationComponent, MovieNav, MovieItem, PlatformNoticeBar },
  watch: {
    cityCode(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        // 定位写 vuex 时若本页已按该城市加载过，不再重复拉接口
        if (this.dataLoaded && this._loadedCityCode === newVal) {
          this.form.cityCode = newVal;
          return;
        }
        this.dataLoaded = false;
        this.form.cityCode = newVal;
        this.initView();
      }
    },
  },
  methods: {
    goShop() {
      // 不缓存 fullTree：GoodsList 只认 MALL_GOODS；交给 navigateToGoodsList 拉取
      navigateToGoodsList(this, { name: '全部' });
    },
    // 去往电影详情页
    goMovieDetail(val) {
      let type = this.canBuy(val) ? 1 : 2;
      this.$router.push({
        path: "/MovieDetail",
        query: {
          showbutton: type,
          item: JSON.stringify(val),
        },
      });
    },
    // 去往影院列表页面
    goCinema(val) {
      this.$router.push({
        path: "/Cinema",
        query: {
          filmId: val.filmId,
          movieName: val.name,
        },
      });
    },
    // 判断是否可购票
    canBuy(item) {
      let newDate = this.$moment().format('YYYY-MM-DD HH:mm:ss');
      let dateRange = this.$moment(newDate).diff(this.$moment(item.publishDate), 'second');
      return dateRange > 0;
    },
    Switch() {
      this.$router.push("SelectAdderss");
    },
    // 顶部客服入口
    openCustomerService,
    goMore() {
      this.$router.push({
        path: "/MoviesList",
      });
    },

    queryHotMoviesByCity() {
      this.$api
        .queryHotMoviesByCity(this.cardId, this.form.cityCode, '')
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.movies = [];
            return;
          }
          this.movies = res.data || []
          this.loading = false
        })
        .catch((err) => {
          this.$Toast(err.msg);
          this.loading = false
        });
    },

    getCategoryList() {
      // 与商城首页同源：拿未裁剪的 categoryList，再截取电影页卡片
      this.$api
        .queryHomePageCategory(this.bathId, this.upgradeFlag, this.form.cityCode)
        .then((res) => {
          if (res.code === 0 && res.data) {
            // 无权限时后端可能直接返回 []，正常为 { navItems, categoryList }
            this.categoryList = Array.isArray(res.data)
              ? []
              : (res.data.categoryList || []);
            this.parseCategoryPermissions();
          } else {
            // 接口返回错误，也标记为已加载
            this.categoryLoaded = true;
          }
        })
        .catch((err) => {
          console.log('获取分类失败:', err);
          // 失败也标记为已加载，防止永远显示loading
          this.categoryLoaded = true;
        });
    },
    /**
     * 从商城首页 fullTree 截取电影页板块：
     * - 视听会员：名称匹配影视文娱/文娱生活
     * - 观影美食：navRoute=FoodBrandList，或名称含餐饮自提（兼容）
     * - 热门演出：仅一级 3313（电商频道）下的二级 3328（大麦演出），其他淘福客子频道不放入
     * - 缤纷商城：其余非门户一级（蛋糕/电影/礼包等门户不计入）
     */
    parseCategoryPermissions() {
      // 电影首页「热门演出」固定指向电商频道 > 大麦演出
      const HOT_SHOW_L1_ID = '3313';
      const HOT_SHOW_L2_ID = '3328';
      const HOT_SHOW_JUMP = 'TFK_DMYC';

      this.showVideoMember = false;
      this.showFoodOrder = false;
      this.showHotShow = false;
      this.showShop = false;
      this.shopCategoryList = [];
      this.videoMemberCategory = null;
      this.foodOrderCategory = null;
      this.hotShowCategory = null;
      this.videoMemberList = [];
      this.foodBrandList = [];
      this.hotShowBrandList = [];

      this.categoryList.forEach(category => {
        const name = category.name || '';
        const navRoute = category.navRoute || '';
        const categoryId = String(category.id || '');

        if (name.includes('影视文娱') || name.includes('文娱生活')) {
          this.showVideoMember = true;
          this.videoMemberCategory = category;
          this.videoMemberList = category.children || [];
        } else if (navRoute === 'FoodBrandList' || name.includes('餐饮自提')) {
          this.showFoodOrder = true;
          this.foodOrderCategory = category;
          this.foodBrandList = category.children || [];
        } else if (categoryId === HOT_SHOW_L1_ID || name.includes('电商频道')) {
          // 只保留大麦演出；无权限/无该子类则不展示入口
          const damaiList = (category.children || []).filter(child => {
            const childId = String(child.id || '');
            return childId === HOT_SHOW_L2_ID || child.jumpPageFlag === HOT_SHOW_JUMP;
          });
          if (damaiList.length > 0) {
            this.showHotShow = true;
            this.hotShowCategory = category;
            this.hotShowBrandList = damaiList;
          }
        } else if (isPortalL1(category)) {
          // 门户/聚合（蛋糕、电影、礼包、生活便利等）不进缤纷商城入口
        } else {
          this.showShop = true;
          this.shopCategoryList.push(category);
        }
      });
      // 分类解析完成，标记为已加载
      this.categoryLoaded = true;
    },

    goToCategory(category) {
      if (!category) return;
      navigateToGoodsList(this, category);
    },
    goToFoodBrandList(category) {
      if (!category) return;
      if (this.foodBrandList && this.foodBrandList.length > 0) {
        cacheAggregateChildren('FoodBrandList', this.foodBrandList);
        this.$router.push({
          path: "/FoodBrandList",
          query: { title: '观影美食' }
        });
      } else {
        this.$Toast.fail('暂无观影美食数据');
      }
    },
    goToHotShowBrandList(category) {
      if (!category) return;
      if (this.hotShowBrandList && this.hotShowBrandList.length > 0) {
        cacheAggregateChildren('TaofukeBrandList', this.hotShowBrandList);
        this.$router.push({
          path: "/TaofukeBrandList",
          query: { title: '热门演出' }
        });
      } else {
        this.$Toast.fail('暂无热门演出数据');
      }
    },
    /** 餐饮自提 / 淘福客二级：getEntrance 跳三方 H5 */
    goToThirdH5(item) {
      if (item.jumpPageFlag) {
        this.$api
          .getEntrance(item.jumpPageFlag)
          .then((res) => {
            if (res.code === 0) {
              window.location.href = res.data;
            } else {
              this.$Toast.fail(res.msg);
            }
          })
          .catch((err) => {
            console.log('跳转失败:', err);
            this.$Toast.fail('跳转失败');
          });
      } else {
        this.$Toast('暂无跳转链接');
      }
    },
    goToCategoryDetail(category, index) {
      if (!category) return;
      const child = (category.children || [])[index];
      if (child) {
        navigateToGoodsList(this, {
          id: child.id,
          name: child.name,
          navLevel: 2,
          parentId: category.id,
          parentName: category.name,
        });
        return;
      }
      navigateToGoodsList(this, category);
    },
    /** 解析当前城市：form → vuex → localStorage */
    resolveCityCode() {
      if (!this.form.cityCode) {
        this.form.cityCode = this.cityCode || localStorage.getItem('cityCode') || '';
      }
      return this.form.cityCode;
    },
    /** 当前批次+城市是否已加载，避免 beforeRouteEnter / 定位 finish / cityCode watch 重复请求 */
    isSameLoadedContext(bathId, cityCode) {
      return this.dataLoaded
        && this._loadedBathId === bathId
        && this._loadedCityCode === cityCode
        && !!cityCode;
    },
    initView() {
      // 换卡后强制重新拉权限与热映
      const currentBathId = localStorage.getItem('bathId');
      if (this._lastBathId && this._lastBathId !== currentBathId) {
        this.dataLoaded = false;
      }
      this._lastBathId = currentBathId;

      this.cardId = localStorage.getItem('cardId');
      this.upgradeFlag = localStorage.getItem('upgradeFlag');
      this.bathId = currentBathId;
      this.resolveCityCode();

      // 城市未就绪时不置 dataLoaded，等定位回调再刷
      if (!this.form.cityCode) {
        return;
      }

      if (this.isSameLoadedContext(currentBathId, this.form.cityCode)) {
        return;
      }

      this.dataLoaded = true;
      this._loadedBathId = currentBathId;
      this._loadedCityCode = this.form.cityCode;
      this.categoryLoaded = false;
      this.queryHotMoviesByCity();
      this.getCategoryList();
    },

    onLocationFinish(locationInfo) {
      const nextCity = (locationInfo && locationInfo.cityCode) || '';
      if (nextCity) {
        this.form.cityCode = nextCity;
      }
      // 定位组件进入页总会再 emit 一次；同城已加载则跳过，避免双请求
      const bathId = localStorage.getItem('bathId');
      if (this.isSameLoadedContext(bathId, this.form.cityCode)) {
        return;
      }
      this.dataLoaded = false;
      this.initView();
    },

  },
  computed: {
    ...mapState({
      address: state => state.address,
      cityCode: state => state.cityCode
    }),
    // 判断是否有其他板块（商城、视听、美食、演出）
    hasOtherSections() {
      let count = 0;
      if (this.showShop) count++;
      if (this.showVideoMember) count++;
      if (this.showFoodOrder) count++;
      if (this.showHotShow) count++;
      return count >= 2;
    },
    // 处理首页展示的电影列表：按评分排序并限制数量
    displayMovies() {
      if (!this.movies || this.movies.length === 0) return [];
      
      // 先克隆数组
      let sorted = [...this.movies];
      
      // 首页仅展示前 10 条高质量影片
      return sorted.slice(0, 10);
    }
  },

  beforeRouteEnter(to, from, next) {
    // 从影院详情返回保留缓存；从商城/卡列表等进入再拉数据
    if (from.path === '/MovieDetail') {
      next();
      return;
    }
    next((vm) => {
      vm.$nextTick(() => {
        const bathId = localStorage.getItem('bathId');
        const city = vm.form.cityCode || vm.cityCode || localStorage.getItem('cityCode') || '';
        // 定位 finish 可能已先加载成功，同上下文不再强制刷，避免双请求
        if (!vm.isSameLoadedContext(bathId, city)) {
          vm.dataLoaded = false;
          vm.initView();
        }
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });
    });
  },
  mounted() {
  },
}
</script>
<style lang="scss" scoped>
.page-container {
  height: 100vh;
  background: #f5f5f5;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 顶部渐变背景 */
.top-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 15rem;
  background: linear-gradient(180deg, #ff6b4a 0%, #ff8a65 50%, #ffb088 100%);
  border-radius: 0 0 2rem 2rem;
  z-index: 0;
}

/* 顶部导航栏：定位居中，客服固定贴右 */
.top-header {
  position: relative;
  z-index: 10;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.location-bar {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.25);
  padding: 0.6rem 1.2rem;
  border-radius: 2rem;
  color: #fff;
  font-size: 0.95rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &:active {
    transform: scale(0.98);
    background: rgba(255, 255, 255, 0.35);
  }
}

/* 客服入口：与定位条同风格的毛玻璃圆按钮，固定在右侧不参与居中 */
.service-entry {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.3rem;
  height: 2.3rem;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  color: #fff;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:active {
    transform: translateY(-50%) scale(0.92);
    background: rgba(255, 255, 255, 0.35);
  }
}

.location-icon {
  font-size: 1rem;
  margin-right: 0.4rem;
}

.location-text {
  max-width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.arrow-icon {
  font-size: 0.7rem;
  margin-left: 0.3rem;
  opacity: 0.8;
}

/* 滚动容器 */
.scroll-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 5;
  padding: 0.5rem 0.8rem; /* 恢复标准边距 */
  overflow-y: auto; 
  -webkit-overflow-scrolling: touch;
}

/* 版块容器 */
.section-container {
  margin-bottom: 0.8rem;
}

/* 通用卡片样式 */
.section-card {
  background: #fff;
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

/* 版块标题 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.8rem;
}

.section-title {
  display: flex;
  align-items: center;
}

.title-icon {
  font-size: 1.2rem;
  margin-right: 0.5rem;
}

.title-text {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.section-more {
  color: #ff6b4a;
  font-size: 0.8rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  
  .iconfont {
    font-size: 0.7rem;
    margin-left: 0.2rem;
  }
}

/* 商城入口卡片 */
.shop-entry-card {
  background: linear-gradient(135deg, #fff 0%, #fff8f5 100%);
  border-radius: 1rem;
  padding: 1rem 1.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 20px rgba(255, 107, 74, 0.15);
  border: 1px solid rgba(255, 107, 74, 0.1);
  transition: all 0.3s ease;
  
  &:active {
    transform: scale(0.98);
    box-shadow: 0 2px 10px rgba(255, 107, 74, 0.2);
  }
}

.shop-entry-left {
  display: flex;
  align-items: center;
}

.shop-entry-icon-wrapper {
  width: 3rem;
  height: 3rem;
  background: linear-gradient(135deg, #ff6b4a 0%, #ff8a65 100%);
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.8rem;
  box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);
}

.shop-entry-icon {
  font-size: 1.5rem;
  filter: brightness(1.2);
}

.shop-entry-content {
  display: flex;
  flex-direction: column;
}

.shop-entry-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.2rem;
}

.shop-entry-subtitle {
  font-size: 0.75rem;
  color: #999;
}

.shop-entry-btn {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #ff6b4a 0%, #ff8a65 100%);
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 1.5rem;
  font-size: 0.85rem;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);
  
  .iconfont {
    font-size: 0.7rem;
    margin-left: 0.3rem;
  }
}

/* 横向滚动 */
.horizontal-scroll {
  display: flex;
  overflow-x: auto;
  padding: 0.3rem 0;
  margin: 0 -0.5rem;
  padding-left: 0.5rem;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    display: none;
  }
}

/* 分类项 */
.category-item {
  flex-shrink: 0;
  width: 4.5rem;
  margin-right: 1rem;
  text-align: center;
  transition: transform 0.2s ease;
  
  &:active {
    transform: scale(0.95);
  }
}

.category-icon-wrapper {
  width: 3.8rem;
  height: 3.8rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.category-icon {
  width: 3rem;
  height: 3rem;
}

.category-name {
  color: #333;
  font-size: 0.75rem;
  margin-top: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 空状态占位 */
.empty-placeholder {
  padding: 2rem;
  text-align: center;
  color: #ccc;
  font-size: 0.85rem;
}

/* 电影版块区域 */
.movie-section {
  background: #fff;
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 2;
  margin-bottom: 4rem;

  &.is-vertical-only {
    margin-bottom: 4.2rem;
  }
}

/* 竖向列表包装器 */
.movie-item-wrapper {
  padding: 0 0.2rem 1rem;
}

.movie-bottom-more {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1.2rem auto; /* 调整外边距使上下间距视觉平衡 */
  width: 12rem;
  padding: 0.7rem 0;
  background: linear-gradient(135deg, #ff6b4a 0%, #ff8a65 100%); /* 与主题色一致 */
  border: none;
  border-radius: 2rem;
  color: #fff; /* 文字改为白色 */
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 4px 10px rgba(255, 107, 74, 0.2);
  transition: all 0.2s ease;
  
  i {
    margin-left: 0.5rem;
    font-size: 0.8rem;
    opacity: 0.9;
  }
  
  &:active {
    transform: scale(0.96);
    opacity: 0.9;
  }
}

.movie-section .movie-header {
  margin-bottom: 0.8rem;
}

.movie-title .title-text {
  color: #333;
}

.movie-more {
  color: #ff6b4a;
}

.movie-scroll {
  padding-bottom: 0.5rem;
}

/* 电影卡片 */
.movie-card {
  flex-shrink: 0;
  width: 6rem;
  margin-right: 0.8rem;
  transition: transform 0.2s ease;
  
  &:active {
    transform: scale(0.95);
  }
}

.movie-poster-wrapper {
  position: relative;
  width: 6rem;
  height: 8rem;
  border-radius: 0.6rem;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.movie-poster {
  width: 100%;
  height: 100%;
}

.poster-score {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(135deg, #ff6b4a 0%, #ff8a65 100%);
  padding: 0.1rem 0.35rem;
  border-bottom-right-radius: 0.5rem;
  color: #fff;
  font-size: 0.6rem;
  font-weight: 600;
  z-index: 1;
}

.poster-version {
  position: absolute;
  bottom: 0.3rem;
  right: 0.3rem;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0.05rem 0.25rem;
  border-radius: 0.2rem;
  font-size: 0.5rem;
  color: #eee;
  white-space: nowrap;
  z-index: 1;
}

.movie-info {
  margin-top: 0.5rem;
  text-align: center;
}

.movie-name {
  color: #333;
  font-size: 0.8rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0.4rem;
}

.movie-buy-btn {
  display: inline-block;
  background: linear-gradient(135deg, #ff6b4a 0%, #ff8a65 100%);
  color: #fff;
  font-size: 0.7rem;
  padding: 0.2rem 0.8rem;
  border-radius: 1rem;
  font-weight: 500;
  box-shadow: 0 4px 10px rgba(255, 107, 74, 0.25);
}

/* 电影空状态 */
.movie-empty {
  padding: 3rem 1rem;
  text-align: center;
  background: #f9f9f9;
  border-radius: 0.8rem;
  margin-top: 1rem;
}

.movie-empty-icon {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  opacity: 0.8;
}

.movie-empty-text {
  color: #333;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.movie-empty-tip {
  color: #999;
  font-size: 0.85rem;
}

/* 骨架屏加载状态 */
.movie-skeleton {
  padding: 0.5rem 0;
}

.skeleton-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.8rem;
  padding: 0.8rem;
  margin-bottom: 0.8rem;
  
  :deep(.van-skeleton) {
    padding: 0;
    background: transparent;
    
    .van-skeleton__avatar {
      background: rgba(255, 255, 255, 0.08);
    }
    
    .van-skeleton__row, .van-skeleton__title {
      background: rgba(255, 255, 255, 0.08);
    }
  }
}

/* 这里的重复定义已合并到上方 */
</style>